import React, { useState } from "react";
import { useCreateGreenMilesDemos } from "./hooks/useCreateGreenMilesDemos";

const GreenMilesDemoForm = ({ onSuccess, onCancel }) => {
  const [formData, setFormData] = useState({
    name: "",
  });

  const [validationErrors, setValidationErrors] = useState({});
  const { createDemo, isLoading, error } = useCreateGreenMilesDemos();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Effacer l'erreur de validation pour ce champ
    if (validationErrors[name]) {
      setValidationErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = "Le nom de la démo est obligatoire";
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    // Données par défaut pour la démo
    const payload = {
      name: formData.name.trim(),
      address: "Adresse démo",
      postalCode: "00000",
      city: "Paris",
      country: "France",
      stars: 3,
      numberOfRooms: 10,
    };

    const result = await createDemo(payload);

    if (result.success) {
      onSuccess?.(result.data, result.message);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="bg-white shadow-sm rounded-lg p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Informations de la démo</h3>
        <div className="grid grid-cols-1 gap-4">
          {/* Nom de la démo */}
          <div className="md:col-span-2">
            <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
              Nom de la démo *
            </label>
            <input type="text" id="name" name="name" value={formData.name} onChange={handleInputChange} className={`w-full px-3 py-2 border rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#365644] ${validationErrors.name ? "border-red-500" : "border-gray-300"}`} placeholder="Ex: Hôtel Le Grand Paris" />
            {validationErrors.name && <p className="mt-1 text-sm text-red-600">{validationErrors.name}</p>}
          </div>
        </div>
      </div>

      <div className="bg-white shadow-sm rounded-lg p-6"></div>

      {/* Erreur globale */}
      {error && (
        <div className="bg-red-50 border border-red-200 rounded-md p-4">
          <div className="flex">
            <span className="text-red-400 mr-2">❌</span>
            <div className="text-sm text-red-800">
              <strong>Erreur:</strong> {error}
            </div>
          </div>
        </div>
      )}

      {/* Boutons d'action */}
      <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200">
        <button type="button" onClick={onCancel} className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-[#365644]" disabled={isLoading}>
          Annuler
        </button>
        <button type="submit" disabled={isLoading} className="px-4 py-2 text-sm font-medium text-white bg-[#365644] border border-transparent rounded-md shadow-sm hover:bg-[#2d4c3c] focus:outline-none focus:ring-2 focus:ring-[#365644] disabled:opacity-50 disabled:cursor-not-allowed">
          {isLoading ? (
            <div className="flex items-center">
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
              Création en cours...
            </div>
          ) : (
            "Créer la démo GreenMiles"
          )}
        </button>
      </div>
    </form>
  );
};

export default GreenMilesDemoForm;
